// extracted by mini-css-extract-plugin
export default {"container":"category-tags-field_container__UMvkw","box":"category-tags-field_box__Kt7VQ"};